import React, { useState, useEffect } from "react";
import Select from "react-select";
import db from "./Firebase"; // your firebase config

function TransferHubLocationModal() {
  const [hubOptions, setHubOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);

  const [selectedHub, setSelectedHub] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedLocations, setSelectedLocations] = useState([]);

  // ✅ Fetch hubs
  useEffect(() => {
    const unsubscribe = db.collection("hubs_master").onSnapshot((snapshot) => {
      const hubs = snapshot.docs.map((doc) => ({
        value: doc.data().hub_name,
        label: doc.data().hub_name,
        id: doc.id,
      }));
      setHubOptions(hubs);
    });
    return () => unsubscribe();
  }, []);

  // ✅ Fetch users when hub selected
  useEffect(() => {
    if (selectedHub) {
      const unsubscribe = db
        .collection("hubs_users_data")
        .where("hub_name", "==", selectedHub.value)
        .onSnapshot((snapshot) => {
          const users = snapshot.docs.map((doc) => ({
            value: doc.id,
            label: `${doc.data().first_name} ${doc.data().last_name}`,
          }));
          setUserOptions(users);
        });
      return () => unsubscribe();
    }
  }, [selectedHub]);

  // ✅ Fetch locations when user selected
  useEffect(() => {
    if (selectedUser) {
      const unsubscribe = db
        .collection("hubs_locations_data")
        .where("delivery_executive", "==", selectedUser.value)
        .onSnapshot((snapshot) => {
          const locs = snapshot.docs.map((doc) => ({
            id: doc.id,
            name: doc.data().location,
          }));
          setLocationOptions(locs);
        });
      return () => unsubscribe();
    }
  }, [selectedUser]);

  // ✅ Handle location checkbox select
  const handleLocationSelect = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedLocations((prev) => [...prev, value]);
    } else {
      setSelectedLocations((prev) => prev.filter((loc) => loc !== value));
    }
  };

  // ✅ Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Hub:", selectedHub);
    console.log("User:", selectedUser);
    console.log("Locations:", selectedLocations);

    // Example: Update locations to assign to user
    for (let loc of selectedLocations) {
      const snapshot = await db
        .collection("hubs_locations_data")
        .where("location", "==", loc)
        .get();

      snapshot.forEach((doc) => {
        db.collection("hubs_locations_data").doc(doc.id).update({
          delivery_executive: selectedUser.value,
          hub_name: selectedHub.value,
          updated_date: new Date(),
        });
      });
    }
    alert("✅ Locations transferred successfully!");
  };

  return (
    <div
      className="modal fade"
      id="transferModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="transferLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="transferLabel">
              Transfer Hub Locations
            </h5>
            <button
              type="button"
              className="close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {/* Hub Selection */}
              <div className="form-group">
                <label>Select Hub</label>
                <Select
                  options={hubOptions}
                  value={selectedHub}
                  onChange={setSelectedHub}
                  placeholder="Choose Hub"
                />
              </div>

              {/* User Selection */}
              <div className="form-group">
                <label>Select User</label>
                <Select
                  options={userOptions}
                  value={selectedUser}
                  onChange={setSelectedUser}
                  placeholder="Choose User"
                />
              </div>

              {/* Location Selection */}
              <div className="form-group">
                <label>Select Locations</label>
                {locationOptions.map((loc) => (
                  <div className="form-check" key={loc.id}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      value={loc.name}
                      onChange={handleLocationSelect}
                      id={loc.id}
                    />
                    <label className="form-check-label" htmlFor={loc.id}>
                      {loc.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-success">
                Transfer
              </button>
              <button
                type="button"
                className="btn btn-light"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default TransferHubLocationModal;
